import React, { useRef } from "react";
import {
    InputAdornment,
    OutlinedInput,
} from '@material-ui/core';

import { useCustomStyles } from "../../../../utils";

import "./NumberInput.scss";

const NumberInput = ({
    value,
    min = 0,
    max,
    endAdornment,
    onChange,
    noOnCountdown = true,
    id,
    label,
    style,
    debounceMs = 100,
}: {
    value?: number;
    min?: number;
    max?: number;
    endAdornment?: string;
    onChange: (_value: number) => void;
    noOnCountdown?: boolean;
    id?: string;
    label?: string;
    style?: React.CSSProperties;
    debounceMs?: number;
}) => {
    const classes = useCustomStyles();
    const inputRef = useRef<HTMLInputElement>(null);
    const debounceTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    // Prevents the infinite increment (decrement) bug in Chrome
    // by losing focus on the input when a browser stepper is clicked
    const handleNumberInputMouseDown = (e: React.MouseEvent<HTMLInputElement>) => {
        const input = inputRef.current;
        if (!input) {
            return;
        }

        const rect = input.getBoundingClientRect();
        const clickX = e.clientX - rect.left;

        const stepperZoneStart = rect.width - 30;
        if (clickX >= stepperZoneStart) {
            setTimeout(() => input.blur(), 100);
        }
    };
    return (<div className="number-input" style={style}>
        {label && <label htmlFor={id} className="number-input__label">{label}</label>}
        <OutlinedInput
            id={id}
            value={value}
            className={classes.numberInput}
            type="number"
            placeholder={label}
            endAdornment={endAdornment && <InputAdornment position="end">{endAdornment}</InputAdornment>}
            onMouseDown={noOnCountdown ? undefined : handleNumberInputMouseDown}
            inputRef={inputRef}
            onChange={({ target }) => {
                const val = Number(target.value);
                if (isNaN(val) || val < 0) {
                    return;
                }
                const clampedVal = min !== undefined && val < min ? min
                    : max !== undefined && val > max ? max
                    : val;
                if (!debounceMs) {
                    onChange?.(clampedVal);
                    return;
                }
                if (debounceTimerRef.current) {
                    clearTimeout(debounceTimerRef.current);
                }
                debounceTimerRef.current = setTimeout(() => onChange?.(clampedVal), debounceMs);
            }}
            inputProps={{ min, max }}
        />
    </div>
    );
};

export default NumberInput;